import React from "react";

const LinkedInShare = () => (
  <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.64258 0C1.18358 0 0 1.18163 0 2.64062C0 4.09963 1.18263 5.30859 2.64062 5.30859C4.09863 5.30859 5.2832 4.09963 5.2832 2.64062C5.2832 1.18263 4.10158 0 2.64258 0ZM15.5352 7C13.3162 7 12.0465 8.16045 11.4375 9.31445H11.373V7.31055H7V22H11.5566V14.7285C11.5566 12.8125 11.7013 10.9609 14.0723 10.9609C16.4093 10.9609 16.4434 13.1456 16.4434 14.8496V22H20.9941H21V13.9316C21 9.98364 20.1512 7 15.5352 7ZM0.363281 7.31055V22H4.92383V7.31055H0.363281Z" fill="#0098F0"/>
</svg>
);

export default LinkedInShare;
